import Vue from 'vue'
import BaseModel from './BaseModel'
import qs from 'qs'

class Collection extends BaseModel {
    constructor(createItemCb = undefined, params = {}) {
        super(params)
        this._items = []
        this._params = params
        this._createItemCb = createItemCb
        this._itemProto = null
        this._showAll = false
        if (createItemCb) {
            this._itemProto = createItemCb({})
            if (this._itemProto) this.apiBase = this._itemProto.apiBase
        }
    }

    get length() {
        return this._items.length
    }

    get items() {
        return this._items
    }

    set items(items) {
        items.forEach((el) => this.push(el))
    }

    findItem(id) {
        if (!id) return null
        if (typeof id === 'string') id = parseInt(id)
        return this.items.find((item) => item.id === id)
    }

    [Symbol.iterator]() {
        return Object.keys(this.items)
            .map((key) => this.items[key])
            .values()
    }

    createItem(item) {
        return this._createItemCb ? this._createItemCb(item) : item
    }

    reset() {
        super.reset()
        this._items = []
    }

    fetch(params = {}, dontReset = false, extraOptions, loader = true) {
        if (loader) this._loading = true
        this._params = Object.assign({}, this._params, params)
        return new Promise((resolve, reject) => {
            try {
                const params = qs.stringify(
                    {
                        ...this._params,
                    },
                    {
                        encode: true,
                        arrayFormat: Vue.prototype.$arrayFormat,
                    }
                )
                const url = this.base + (params !== '' ? `?${params}` : '')
                window?.debug?.info(`Fetching Collection: ${this.apiBase}\n url: ${url}`)
                this._client
                    .index(url, extraOptions)
                    .then((res) => {
                        if ((!dontReset && !this._showAll) || extraOptions?.resetList) this.reset()

                        if (res) {
                            if (this._showAll) {
                                if (this.items.length === 0) {
                                    this.items.length = res.total
                                    this.items.fill(null)
                                }
                                this.items.splice(
                                    (res.current_page - 1) * res.limit,
                                    res.limit,
                                    ...res.list
                                )
                            } else {
                                this.items = res.data || res.list || res
                            }
                            this._loaded = true
                        }
                        return resolve(res)
                    })
                    .finally(() => {
                        if (loader) this._loading = false
                    })
            } catch (e) {
                if (loader) this._loading = false
                this._loaded = false
                return reject(e)
            }
        })
    }

    push(item, type = '_items') {
        const idx = this[type]?.findIndex((el) => el.id === item.id)
        if (idx === -1) this[type]?.push(item)
    }

    unshift(item, type = '_items') {
        const idx = this[type]?.findIndex((el) => el.id === item.id)
        if (idx === -1) this[type]?.unshift(this.createItem(item))
    }

    remove(item, type = '_items') {
        const idx = this[type]?.findIndex((el) => el.id === item.id)
        if (idx !== -1) this[type]?.splice(idx, 1)
    }
}

export default Collection
